// extracted by mini-css-extract-plugin
export var badge = "_i7-2";
export var detailsPanel = "_i7-0";
export var resultRow = "_i7-1";